// Store filter toggle (Australia / International). Shown only to members who can see BOTH stores;
// single-store members have nothing to switch. Bound to the shared store context so the choice
// persists and stays in sync everywhere it's used. Rendered INSIDE each module that needs it
// (Orders, Payments, Clients, New order) rather than globally in the top bar.
import { useAuthStore } from '../../stores/authStore.js';
import { useStoreContext } from '../../stores/storeContext.js';
import { STORE_SHORT } from '../../lib/stores.js';

export default function StoreSwitcher() {
  const user = useAuthStore((s) => s.user);
  const activeStore = useStoreContext((s) => s.activeStore);
  const setActiveStore = useStoreContext((s) => s.setActiveStore);

  // Only internal staff choose a store. A CLIENT is scoped to their own company and a REP to their
  // assigned companies, so for them this control did nothing useful and could hide all their own
  // data (storeAccess defaults to BOTH for every user, which is why they saw it at all).
  if (user?.role !== 'INTERNAL_STAFF') return null;
  if (user?.storeAccess !== 'BOTH') return null;

  return (
    <div
      className="inline-flex items-center gap-1 rounded-md border border-line bg-surface-raised p-0.5"
      role="group"
      aria-label="Store"
    >
      {['A', 'B'].map((code) => (
        <button
          key={code}
          type="button"
          onClick={() => setActiveStore(code)}
          aria-pressed={activeStore === code}
          className={`rounded px-2.5 py-1 text-xs font-medium transition ${
            activeStore === code ? 'bg-accent text-white' : 'text-text-secondary hover:text-text-primary'
          }`}
        >
          {STORE_SHORT[code]}
        </button>
      ))}
    </div>
  );
}
